import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
  withNoHttpTransferCache,
} from '@angular/platform-browser';
import { AppModule } from './app.module';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { SrpToggleComponent } from './spartacus/features/header/srp-toggle/srp-toggle.component';
import { ShimanoImageZoomComponent } from './spartacus/features/shimano-image-zoom/shimano-image-zoom.component';
import { TawkLiveChatComponent } from './spartacus/features/tawk-live-chat/tawk-live-chat.component';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideClientHydration(withEventReplay(), withNoHttpTransferCache()),
    importProvidersFrom(AppModule),
    //Component-Driven Outlets 
    provideOutlet({ 
      id: 'SrpToggle',
      position: OutletPosition.REPLACE,
      component: SrpToggleComponent,
    }),
      provideOutlet({
      id: 'ProductImagesComponent',
      position: OutletPosition.AFTER,
      component: ShimanoImageZoomComponent,
    }),
    provideOutlet({
      id: 'header',
      position: OutletPosition.AFTER,
      component: TawkLiveChatComponent,
    }),
  ],
};
